import React, { useState, forwardRef, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { Dropdown } from 'react-bootstrap';
import MaterialTable from "material-table";
import { Search, ViewColumn, SaveAlt, Remove, LastPage, FirstPage, FilterList, Edit, DeleteOutline, Clear, ChevronRight, ChevronLeft, Check, ArrowDownward, AddBox } from '@material-ui/icons';
import { useTranslation } from "react-i18next";
import Loader from '../../pages/Loader';
import axios from 'axios';
import moment from 'moment';

import { CsvBuilder } from 'filefy';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { checkauhtoken } from '../../../api/PrePageLoad';

const materialTableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

export const Fiat_Transactions = () => {
    const { t } = useTranslation();
    const [loader, setLoader] = useState(false);
    const [trasarray, setTrasarray] = useState([]);
    const [outtrasarray, setOutTrasarray] = useState([]);
    const [Internaldata, setInternaldata] = useState([]);
    const [Outgoingdata, setOutgoingdata] = useState([]);
    const [Useraccount, setUseracccount] = useState([]);
    const [fiataccount, setfiataccount] = useState([]);
    const [mainfiataccount, setMainfiataccount] = useState([]);

    const [AccountInformation, setAccountInformation] = useState(false);
    const [InternalModal, setInternalModal] = useState(false);

    const [modalFromUser, setmodalFromUser] = useState("");
    const [modalToUser, setmodalToUser] = useState("");
    const [modalFromAccount, setmodalFromAccount] = useState("");
    const [modalToAccount, setmodalToAccount] = useState("");
    const [modalMessage, setmodalMessage] = useState("");
    const [modalAmount, setmodalAmount] = useState("");
    const [modalCurrency, setmodalCurrency] = useState("");
    const [modalEmailAddress, setmodalEmailAddress] = useState("");

    const [modal_outgoing_accno, setmodal_outgoing_accno] = useState("");
    const [modal_outgoing_swiftcode, setmodal_outgoing_swiftcode] = useState("");
    const [modal_outgoing_bankname, setmodal_outgoing_bankname] = useState("");
    const [modal_outgoing_address, setmodal_outgoing_address] = useState("");
    const [modal_outgoing_country, setmodal_outgoing_country] = useState("");
    const [modal_outgoing_rtn, setmodal_outgoing_rtn] = useState("");
    const [modal_outgoing_location, setmodal_outgoing_location] = useState("");
    const [modal_outgoing_cusname, setmodal_outgoing_cusname] = useState("");
    const [modal_outgoing_cusiban, setmodal_outgoing_cusiban] = useState("");
    const [modal_outgoing_refmsg, setmodal_outgoing_refmsg] = useState("");
    const [modal_outgoing_cusaddress, setmodal_outgoing_cusaddress] = useState("");
    const [modal_outgoing_amount, setmodal_outgoing_amount] = useState("");
    const [modal_outgoing_currency, setmodal_outgoing_currency] = useState("");
    const [modal_outgoing_message, setmodal_outgoing_message] = useState("");



    const [from_date, setfrom_date] = useState("");
    const [to_date, setto_date] = useState("");
    const [account, setaccount] = useState("");

    const [TransactionType, setTransactionType] = useState("Fiat");
    const handleChangeTransactionType = (TransactionTypeVal) => {
        setTransactionType(TransactionTypeVal);
        document.getElementById("Fiat").style.display = "none";
        document.getElementById("InternalTransfers").style.display = "none";
        document.getElementById("OutgoingTransfers").style.display = "none";
        document.getElementById(TransactionTypeVal).style.display = "block";
        setfrom_date("");
        setto_date("");
        setaccount("");
    }


    const handleChangeCSVNdPDF = (val) => {
        let FileName = "Transactions";
        let FileData;
        let newarray = fiataccount;
        let columns = [
            { title: t('LABEL.ID'), field: 'ID' },
            { title: t('HEADER.CUS_NAME'), field: 'CustomerName' },
            { title: t('HEADER.CUS_EMAIL'), field: 'EmailID' },
            { title: t('ACCOUNT_TRANSACTIONS.DATE'), field: 'Date' },
            { title: t('TRANSACTION.TYPE'), field: 'Type' },
            { title: t('TRANSACTION.PAIR'), field: 'Pair' },
            { title: t('LABEL.FEES_LA'), field: 'Fees' },
            { title: t('TRANSACTION.FIAT_AMOUNT'), field: 'FiatAmount' },
            { title: t('TRANSACTION.AMOUNT'), field: 'Amount' },
            { title: t('TRANSACTION.STATUS_LA'), field: 'Status', align: 'center' },
        ];

        if (TransactionType === "Fiat") {
            FileName = "Fiat Account";
            newarray = fiataccount;
            let columns = [
                { title: t('TRANSACTION.DATE_LA'), field: 'date' },
                { title: t('TRANSACTION.TRANSACTION_DETAILS'), field: 'transaction_details' },
                { title: t('TRANSACTION.DEBIT_LA'), field: 'type' },
                { title: t('TRANSACTION.AMOUNT'), field: 'amount' },
                { title: t('TRANSACTION.BALANCE_LA'), field: 'balance' },
            ];

             FileData = newarray.map(rowData =>
                [rowData["date"],
                rowData["transaction_details"],
                rowData["type"],
                rowData["amountText"],
                rowData["balance"]]
            );

        } else if (TransactionType === "InternalTransfers") {
            FileName = "Internal Transactions";
            newarray = trasarray;
            let columns = [
                { title: t('TRANSACTION.FROM_ACCOUNT'), field: 'account_number' },
                { title: t('TRANSACTION.TO_EMAILID'), field: 'email_address' },
                { title: t('TRANSACTION.AMOUNT'), field: 'amount' },
                { title: t('TRANSACTION.CUR_LA'), field: 'currency' },
                { title: t('TRANSACTION.STATUS_LA'), field: 'status' },
            ];

             FileData = newarray.map(rowData =>
                [rowData["account_number"],
                rowData["email_address"],
                rowData["amount"],
                rowData["currency"],
                rowData["statusText"]]
            );
        } else if (TransactionType === "OutgoingTransfers") {
            FileName = "Outgoing Transactions";
            newarray = outtrasarray;
            let columns = [
                { title: t('TRANSACTION.BEN_ACC_NAME'), field: 'bank_account_name' },
                { title: t('TRANSACTION.ACC_NO'), field: 'account_number' },
                { title: t('TRANSACTION.AMOUNT'), field: 'amount' },
                { title: t('TRANSACTION.CUR_LA'), field: 'currency' },
                { title: t('TRANSACTION.STATUS_LA'), field: 'status' },
            ];

             FileData = newarray.map(rowData =>
                [rowData["bank_account_name"],
                rowData["account_number"],
                rowData["amount"],
                rowData["currency"],
                rowData["statusText"]]
            );
        }
        const columnTitles = columns.map(columnDef => columnDef.title);


        if (val === "CSV") {
            const builder = new CsvBuilder(FileName + `.csv`)
                .setColumns(columnTitles)
                .addRows(FileData)
                .exportFile();

            return builder;
        }
        else if (val === "PDF") {
            const doc = new jsPDF();

            doc.autoTable({
                head: [columnTitles],
                body: FileData,
            });

            doc.save(FileName + `.pdf`);
        }
    }


    useEffect(() => {
        checkauhtoken();
        handleLoad();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleclick = (internalid) => {
        document.getElementById("Fiat").style.display = "none";
        document.getElementById("InternalTransfers").style.display = "block";
        document.getElementById("OutgoingTransfers").style.display = "none";

        let jsonpar = {
            internalid: internalid
        }
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        axios.post(process.env.REACT_APP_API_URL + 'internaltransfer/GetAllInternalDetails', jsonpar, { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    setInternalModal(true);
                    setmodalFromUser(res.data[0].modalfromuseraccount);
                    setmodalToUser(res.data[0].modaltouseraccount);
                    setmodalFromAccount(res.data[0].modalfromuser);
                    setmodalToAccount(res.data[0].modaltouser);
                    setmodalEmailAddress(res.data[0].email_address);
                    setmodalCurrency(res.data[0].currency);
                    setmodalMessage(res.data[0].message);
                    setmodalAmount(res.data[0].amount + " " + res.data[0].currency);
                    setTimeout(() => {
                        setLoader(false);
                    }, 3000);
                } else {
                    setLoader(false);
                }
            })
            .catch(function (error) {
                setLoader(false);
            });
    }

    const handleclickoutgoing = (outgoingid) => {
        document.getElementById("Fiat").style.display = "none";
        document.getElementById("InternalTransfers").style.display = "none";
        document.getElementById("OutgoingTransfers").style.display = "block";

        let jsonpar = {
            outgoingid: outgoingid
        }
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        axios.post(process.env.REACT_APP_API_URL + 'outgoingtransfer/GetAllOutgoingDetails', jsonpar, { headers: headers })
            .then(function (res) {
                res = res.data;
                setAccountInformation(true);
                if (res.code === "200") {
                    setmodal_outgoing_accno(res.data[0].account_number);
                    setmodal_outgoing_swiftcode(res.data[0].switch_code);
                    setmodal_outgoing_bankname(res.data[0].bank_name);
                    setmodal_outgoing_address(res.data[0].address1);
                    setmodal_outgoing_country(res.data[0].countryname);
                    setmodal_outgoing_rtn(res.data[0].label);
                    setmodal_outgoing_location(res.data[0].region);
                    setmodal_outgoing_cusname(res.data[0].customer_name);
                    setmodal_outgoing_cusiban(res.data[0].iban_number);
                    setmodal_outgoing_refmsg(res.data[0].referance);
                    setmodal_outgoing_cusaddress(res.data[0].address2);
                    setmodal_outgoing_amount(res.data[0].amount);
                    setmodal_outgoing_currency(res.data[0].bank_currency);
                    setmodal_outgoing_message(res.data[0].message);

                    setTimeout(() => {
                        setLoader(false);
                    }, 3000);
                } else {
                    setLoader(false);
                }
            })
            .catch(function (error) {
                setLoader(false);
            });
    }

    const handleLoad = () => {
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        setLoader(true);
        axios.get(process.env.REACT_APP_API_URL + 'internaltransfer/GetAllInternals', { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    setInternaldata(res.data);
                    setOutgoingdata(res.outgoing);
                    setMainfiataccount(res.balancedata);
                    setUseracccount(res.useraccount);
                    setTimeout(() => {
                        setLoader(false);
                    }, 500);
                    let TempArr = [];
                    res.data.forEach(element => {
                        let amount = "";
                        let popup = <div onClick={(event) => handleclick(element.internal_id)} style={{ width: '160px' }}><Link to="#" className="btn btn-light btn-rounded btn-xs"><i className="fa fa-eye"></i> View Details</Link></div>
                        if (element.currency === "USD") {
                            amount = element.amount + " $";
                        } else {
                            amount = element.amount + " €";
                        }

                        let status = "";
                        if (element.status === "Completed") {
                            status = <div><Link to="#" className="btn btn-outline-success btn-rounded">Completed</Link></div>
                        } else if (element.status === "Pending") {
                            status = <div><Link to="#" className="btn btn-outline-warning btn-rounded">Pending</Link></div>
                        } else if (element.status === "Failed") {
                            status = <div><Link to="#" className="btn btn-outline-danger btn-rounded">Failed</Link></div>
                        }

                        let temp = {
                            account_number: element.account_number,
                            email_address: element.email_address,
                            amount: amount,
                            currency: element.currency,
                            status: status,
                            popup: popup,
                            statusText: element.status,
                        };
                        TempArr.push(temp);

                    

                    });
                    setTrasarray(TempArr);
                    let TempOutArr = [];
                    res.outgoing.forEach(element => {
                        let amount = "";
                        let popup = <div onClick={(event) => handleclickoutgoing(element.fiat_with_trans_id)} style={{ width: '160px' }}><Link className="btn btn-light btn-rounded btn-xs"><i className="fa fa-eye"></i> View Details</Link></div>
                        if (element.bank_currency === "USD") {
                            amount = element.amount + " $";
                        } else {
                            amount = element.amount + " €";
                        }

                        let status = "";
                        if (element.status === "Completed") {
                            status = <div><Link to="#" className="btn btn-outline-success btn-rounded">Completed</Link></div>
                        } else if (element.status === "Pending") {
                            status = <div><Link to="#" className="btn btn-outline-warning btn-rounded">Pending</Link></div>
                        } else if (element.status === "Failed") {
                            status = <div><Link to="#" className="btn btn-outline-danger btn-rounded">Failed</Link></div>
                        }

                        let temp = {
                            bank_account_name: element.bank_account_name,
                            account_number: element.account_number,
                            amount: amount,
                            currency: element.bank_currency,
                            status: status,
                            popup: popup,
                            statusText: element.status,
                        };
                        TempOutArr.push(temp);

                   
                    });
                    setOutTrasarray(TempOutArr);

                    let TempArrfiat = [];
                    res.balancedata.forEach(element => {
                        let amount = "";
                        let current_balance = "";
                        if (element.type === "Debit") {
                            amount = <div><span className="me-2 oi-icon bgl-danger"><svg width="18" height="18" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.57624 0.769646C6.77936 1.18944 6.59993 1.69725 6.18014 1.90038C5.01217 2.46236 4.02363 3.33579 3.31947 4.42928C2.59837 5.54986 2.21582 6.84986 2.21582 8.19048C2.21582 12.0363 5.34394 15.1644 9.18978 15.1644C13.0356 15.1644 16.1637 12.0363 16.1637 8.19048C16.1637 6.84986 15.7812 5.54985 15.0635 4.4259C14.3627 3.33241 13.3708 2.45897 12.2028 1.89699C11.783 1.69387 11.6036 1.18944 11.8067 0.766262C12.0098 0.34647 12.5143 0.167042 12.9374 0.370167C14.3898 1.06756 15.6187 2.1509 16.4887 3.51183C17.3825 4.90663 17.8564 6.52486 17.8564 8.19048C17.8564 10.5061 16.9559 12.6829 15.3174 14.3181C13.6822 15.9566 11.5054 16.8571 9.18978 16.8571C6.87415 16.8571 4.69733 15.9566 3.06217 14.3181C1.42363 12.6795 0.523111 10.5061 0.523111 8.19048C0.523111 6.52486 0.99707 4.90663 1.89421 3.51183C2.76764 2.15428 3.99655 1.06756 5.44551 0.370167C5.86868 0.170427 6.37311 0.34647 6.57624 0.769646Z" fill="#FF2E2E"></path>
                                <path d="M5.89551 7.7402C5.72962 7.57431 5.64837 7.35765 5.64837 7.14098C5.64837 6.92431 5.72962 6.70765 5.89551 6.54176L8.02493 4.41233C8.33639 4.10088 8.74941 3.93161 9.18613 3.93161C9.62285 3.93161 10.0393 4.10426 10.3473 4.41233L12.4768 6.54176C12.8085 6.87353 12.8085 7.40843 12.4768 7.7402C12.145 8.07197 11.6101 8.07197 11.2783 7.7402L10.0291 6.49098L10.0291 11.3017C10.0291 11.7688 9.64993 12.148 9.18275 12.148C8.71556 12.148 8.33639 11.7688 8.33639 11.3017L8.33639 6.4876L7.08717 7.73681C6.76217 8.06858 6.22728 8.06858 5.89551 7.7402Z" fill="#FF2E2E"></path>
                            </svg>
                            </span>&nbsp;&nbsp;{element.amount}</div>;
                        } else {
                            amount = <div>
                                <span className="me-2 oi-icon bgl-success">
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0)">
                                            <path d="M11.4238 16.2304C11.2206 15.8106 11.4001 15.3027 11.8199 15.0996C12.9878 14.5376 13.9764 13.6642 14.6805 12.5707C15.4016 11.4501 15.7842 10.1501 15.7842 8.80952C15.7842 4.96369 12.6561 1.83556 8.81022 1.83556C4.96439 1.83556 1.83626 4.96369 1.83626 8.80952C1.83626 10.1501 2.21881 11.4501 2.93652 12.5741C3.6373 13.6676 4.62923 14.541 5.7972 15.103C6.21699 15.3061 6.39642 15.8106 6.19329 16.2337C5.99017 16.6535 5.48574 16.833 5.06256 16.6298C3.61022 15.9324 2.38131 14.8491 1.51126 13.4882C0.617512 12.0934 0.143554 10.4751 0.143554 8.80952C0.143554 6.49389 1.04408 4.31707 2.68262 2.68192C4.31777 1.04337 6.4946 0.142853 8.81022 0.142854C11.1258 0.142854 13.3027 1.04337 14.9378 2.68192C16.5764 4.32046 17.4769 6.4939 17.4769 8.80952C17.4769 10.4751 17.0029 12.0934 16.1058 13.4882C15.2324 14.8457 14.0034 15.9324 12.5545 16.6298C12.1313 16.8296 11.6269 16.6535 11.4238 16.2304Z" fill="#2BC155" />
                                            <path d="M12.1045 9.2598C12.2704 9.42569 12.3516 9.64235 12.3516 9.85902C12.3516 10.0757 12.2704 10.2924 12.1045 10.4582L9.97506 12.5877C9.66361 12.8991 9.25059 13.0684 8.81387 13.0684C8.37715 13.0684 7.96074 12.8957 7.65267 12.5877L5.52324 10.4582C5.19147 10.1265 5.19147 9.59157 5.52324 9.2598C5.85501 8.92803 6.38991 8.92803 6.72168 9.2598L7.9709 10.509L7.9709 5.69834C7.9709 5.23116 8.35007 4.85199 8.81725 4.85199C9.28444 4.85199 9.66361 5.23116 9.66361 5.69834L9.66361 10.5124L10.9128 9.26319C11.2378 8.93142 11.7727 8.93142 12.1045 9.2598Z" fill="#2BC155" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0">
                                                <rect width="17.3333" height="17.3333" fill="white" transform="matrix(-9.93477e-08 1 1 9.93477e-08 0.143555 0.142853)" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </span>&nbsp;&nbsp;{element.amount}</div>;
                        }

                        if (element.currency_type === "USD") {
                            current_balance = element.current_balance + " USD";
                        } else {
                            current_balance = element.current_balance + " EUR";
                        }

                        let fiatonetemp = {
                            transaction_id: element.balance_sheet_id,
                            date: moment(element.created_datetime).format('MM / DD / YYYY hh:mm:ss'),
                            transaction_details: element.transaction_type,
                            type: element.type,
                            amount: amount,
                            balance: current_balance,
                            account_id_fk: element.created_datetime,
                            amountText: element.amount,
                        };
                        TempArrfiat.push(fiatonetemp);

                    });
                    setfiataccount(TempArrfiat);

                   
                } else {
                    setLoader(false);
                }
            })
            .catch(function (error) {
                setLoader(false);
            });
    }

    const validateFromdate = (value) => {
        setfrom_date(value);
        filter("1," + value, "", "");
    }

    const validateTodate = (value) => {
        setto_date(value);
        filter("", "1," + value, "");
    }

    const validateAccount = (value) => {
        setaccount(value);
        filter("", "", "1," + value);
    }

    const filter = (fromdate = "", todate = "", accountzz = "") => {
        let tempfrom = from_date;
        let temptodate = to_date;
        let tempaccount = account;


        if (fromdate !== "") {
            if (fromdate.split(",")[0] === "1" && fromdate.split(",")[1] !== "") {
                tempfrom = fromdate.split(",")[1];
            }
            else if (fromdate.split(",")[0] === "1" && fromdate.split(",")[1] === "") {
                tempfrom = "";
            }
        }

        if (todate !== "") {
            if (todate.split(",")[0] === "1" && todate.split(",")[1] !== "") {
                temptodate = todate.split(",")[1];
            }
            else if (todate.split(",")[0] === "1" && todate.split(",")[1] === "") {
                temptodate = "";
            }
        }

        if (accountzz !== "") {
            if (accountzz.split(",")[0] === "1" && accountzz.split(",")[1] !== "") {
                tempaccount = accountzz.split(",")[1];
            }
            else if (accountzz.split(",")[0] === "1" && accountzz.split(",")[1] === "") {
                tempaccount = "";
            }
        }

        if (TransactionType === "InternalTransfers") {
            let TempArr = [];
            Internaldata.forEach(element => {
                let amount = "";
                let popup = <div onClick={(event) => handleclick(element.internal_id)}><Link to="#" className="btn btn-light btn-rounded btn-xs"><i className="fa fa-eye"></i> View Details</Link></div>
                if (element.currency === "USD") {
                    amount = element.amount + " $";
                } else {
                    amount = element.amount + " €";
                }

                let status = "";
                if (element.status === "Completed") {
                    status = <div><Link to="#" className="btn btn-outline-success btn-rounded">Completed</Link></div>
                } else if (element.status === "Pending") {
                    status = <div><Link to="#" className="btn btn-outline-warning btn-rounded">Pending</Link></div>
                } else if (element.status === "Failed") {
                    status = <div><Link to="#" className="btn btn-outline-danger btn-rounded">Failed</Link></div>
                }

                let temp = {
                    account_number: element.account_number,
                    email_address: element.email_address,
                    amount: amount,
                    currency: element.currency,
                    status: status,
                    popup: popup,
                };

                if ((tempaccount !== "" && tempaccount.toString() === element.from_account_fk.toString()) && tempfrom === "" && temptodate === "") {
                    TempArr.push(temp);
                }
                else if (tempaccount === "" && (tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') >= moment(tempfrom).format('YYYY-MM-DD')) && temptodate === "") {
                    TempArr.push(temp);
                }
                else if (tempaccount === "" && tempfrom === "" && (temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    TempArr.push(temp);
                }
                else if (tempaccount === "" && (tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') >= moment(tempfrom).format('YYYY-MM-DD')) && (temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    TempArr.push(temp);
                }
                else if ((tempaccount !== "" && tempaccount.toString() === element.from_account_fk.toString()) && (tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') >= moment(tempfrom).format('YYYY-MM-DD')) && (temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    TempArr.push(temp);
                }
                else if (tempaccount === "" && tempfrom === "" && temptodate === "") {
                    TempArr.push(temp);
                }
            });
            setTrasarray(TempArr);
        } else if (TransactionType === "OutgoingTransfers") {
            let TempArrss = [];
            Outgoingdata.forEach(element => {
                let amount = "";
                let popup = <div onClick={(event) => handleclickoutgoing(element.fiat_with_trans_id)}><Link className="btn btn-light btn-rounded btn-xs"><i className="fa fa-eye"></i> View Details</Link></div>
                if (element.bank_currency === "USD") {
                    amount = element.amount + " $";
                } else {
                    amount = element.amount + " €";
                }

                let status = "";
                if (element.status === "Completed") {
                    status = <div><Link to="#" className="btn btn-outline-success btn-rounded">Completed</Link></div>
                } else if (element.status === "Pending") {
                    status = <div><Link to="#" className="btn btn-outline-warning btn-rounded">Pending</Link></div>
                } else if (element.status === "Failed") {
                    status = <div><Link to="#" className="btn btn-outline-danger btn-rounded">Failed</Link></div>
                }

                let temp = {
                    bank_account_name: element.bank_account_name,
                    account_number: element.account_number,
                    amount: amount,
                    currency: element.bank_currency,
                    status: status,
                    popup: popup,
                };

                if ((tempaccount !== "" && tempaccount.toString() === element.account_id_fk.toString()) && tempfrom === "" && temptodate === "") {
                    TempArrss.push(temp);
                }
                else if (tempaccount === "" && (tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') >= moment(tempfrom).format('YYYY-MM-DD')) && temptodate === "") {
                    TempArrss.push(temp);
                }
                else if (tempaccount === "" && tempfrom === "" && (temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    TempArrss.push(temp);
                }
                else if (tempaccount === "" && (tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') >= moment(tempfrom).format('YYYY-MM-DD')) && (temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    TempArrss.push(temp);
                }
                else if ((tempaccount !== "" && tempaccount.toString() === element.account_id_fk.toString()) && (tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') >= moment(tempfrom).format('YYYY-MM-DD')) && (temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    TempArrss.push(temp);
                }
                else if (tempaccount === "" && tempfrom === "" && temptodate === "") {
                    TempArrss.push(temp);
                }
            });
            setOutTrasarray(TempArrss);
        } else if (TransactionType === "Fiat") {
            let TempArrs = [];
            mainfiataccount.forEach(element => {
                let amount = "";
                let current_balance = "";
                if (element.type === "Debit") {
                    amount = <div><span className="me-2 oi-icon bgl-danger"><svg width="18" height="18" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.57624 0.769646C6.77936 1.18944 6.59993 1.69725 6.18014 1.90038C5.01217 2.46236 4.02363 3.33579 3.31947 4.42928C2.59837 5.54986 2.21582 6.84986 2.21582 8.19048C2.21582 12.0363 5.34394 15.1644 9.18978 15.1644C13.0356 15.1644 16.1637 12.0363 16.1637 8.19048C16.1637 6.84986 15.7812 5.54985 15.0635 4.4259C14.3627 3.33241 13.3708 2.45897 12.2028 1.89699C11.783 1.69387 11.6036 1.18944 11.8067 0.766262C12.0098 0.34647 12.5143 0.167042 12.9374 0.370167C14.3898 1.06756 15.6187 2.1509 16.4887 3.51183C17.3825 4.90663 17.8564 6.52486 17.8564 8.19048C17.8564 10.5061 16.9559 12.6829 15.3174 14.3181C13.6822 15.9566 11.5054 16.8571 9.18978 16.8571C6.87415 16.8571 4.69733 15.9566 3.06217 14.3181C1.42363 12.6795 0.523111 10.5061 0.523111 8.19048C0.523111 6.52486 0.99707 4.90663 1.89421 3.51183C2.76764 2.15428 3.99655 1.06756 5.44551 0.370167C5.86868 0.170427 6.37311 0.34647 6.57624 0.769646Z" fill="#FF2E2E"></path>
                        <path d="M5.89551 7.7402C5.72962 7.57431 5.64837 7.35765 5.64837 7.14098C5.64837 6.92431 5.72962 6.70765 5.89551 6.54176L8.02493 4.41233C8.33639 4.10088 8.74941 3.93161 9.18613 3.93161C9.62285 3.93161 10.0393 4.10426 10.3473 4.41233L12.4768 6.54176C12.8085 6.87353 12.8085 7.40843 12.4768 7.7402C12.145 8.07197 11.6101 8.07197 11.2783 7.7402L10.0291 6.49098L10.0291 11.3017C10.0291 11.7688 9.64993 12.148 9.18275 12.148C8.71556 12.148 8.33639 11.7688 8.33639 11.3017L8.33639 6.4876L7.08717 7.73681C6.76217 8.06858 6.22728 8.06858 5.89551 7.7402Z" fill="#FF2E2E"></path>
                    </svg>
                    </span>&nbsp;&nbsp;{element.amount}</div>;
                } else {
                    amount = <div>
                        <span className="me-2 oi-icon bgl-success">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0)">
                                    <path d="M11.4238 16.2304C11.2206 15.8106 11.4001 15.3027 11.8199 15.0996C12.9878 14.5376 13.9764 13.6642 14.6805 12.5707C15.4016 11.4501 15.7842 10.1501 15.7842 8.80952C15.7842 4.96369 12.6561 1.83556 8.81022 1.83556C4.96439 1.83556 1.83626 4.96369 1.83626 8.80952C1.83626 10.1501 2.21881 11.4501 2.93652 12.5741C3.6373 13.6676 4.62923 14.541 5.7972 15.103C6.21699 15.3061 6.39642 15.8106 6.19329 16.2337C5.99017 16.6535 5.48574 16.833 5.06256 16.6298C3.61022 15.9324 2.38131 14.8491 1.51126 13.4882C0.617512 12.0934 0.143554 10.4751 0.143554 8.80952C0.143554 6.49389 1.04408 4.31707 2.68262 2.68192C4.31777 1.04337 6.4946 0.142853 8.81022 0.142854C11.1258 0.142854 13.3027 1.04337 14.9378 2.68192C16.5764 4.32046 17.4769 6.4939 17.4769 8.80952C17.4769 10.4751 17.0029 12.0934 16.1058 13.4882C15.2324 14.8457 14.0034 15.9324 12.5545 16.6298C12.1313 16.8296 11.6269 16.6535 11.4238 16.2304Z" fill="#2BC155" />
                                    <path d="M12.1045 9.2598C12.2704 9.42569 12.3516 9.64235 12.3516 9.85902C12.3516 10.0757 12.2704 10.2924 12.1045 10.4582L9.97506 12.5877C9.66361 12.8991 9.25059 13.0684 8.81387 13.0684C8.37715 13.0684 7.96074 12.8957 7.65267 12.5877L5.52324 10.4582C5.19147 10.1265 5.19147 9.59157 5.52324 9.2598C5.85501 8.92803 6.38991 8.92803 6.72168 9.2598L7.9709 10.509L7.9709 5.69834C7.9709 5.23116 8.35007 4.85199 8.81725 4.85199C9.28444 4.85199 9.66361 5.23116 9.66361 5.69834L9.66361 10.5124L10.9128 9.26319C11.2378 8.93142 11.7727 8.93142 12.1045 9.2598Z" fill="#2BC155" />
                                </g>
                                <defs>
                                    <clipPath id="clip0">
                                        <rect width="17.3333" height="17.3333" fill="white" transform="matrix(-9.93477e-08 1 1 9.93477e-08 0.143555 0.142853)" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </span>&nbsp;&nbsp;{element.amount}</div>;
                }

                if (element.currency_type === "USD") {
                    current_balance = element.current_balance + " USD";
                } else {
                    current_balance = element.current_balance + " EUR";
                }

                let temp = {
                    transaction_id: "#" + element.balance_sheet_id,
                    date: moment(element.created_datetime).format('MM / DD / YYYY hh:mm:ss'),
                    transaction_details: element.transaction_type,
                    type: element.type,
                    amount: amount,
                    balance: current_balance
                };

                if ((tempaccount !== "" && tempaccount.toString() === element.account_id_fk.toString()) && tempfrom === "" && temptodate === "") {
                    TempArrs.push(temp);
                }
                else if (tempaccount === "" && (tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') >= moment(tempfrom).format('YYYY-MM-DD')) && temptodate === "") {
                    TempArrs.push(temp);
                }
                else if (tempaccount === "" && tempfrom === "" && (temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    TempArrs.push(temp);
                }
                else if (tempaccount === "" && (tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') >= moment(tempfrom).format('YYYY-MM-DD')) && (temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    TempArrs.push(temp);
                }
                else if ((tempaccount !== "" && tempaccount.toString() === element.account_id_fk.toString()) && (tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') && temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    TempArrs.push(temp);
                }
                else if (tempaccount === "" && tempfrom === "" && temptodate === "") {
                    TempArrs.push(temp);
                }
            });
            setfiataccount(TempArrs);
        }

    }




    return (
        <div>
            <div className="card transparent-card">
                <div className="card-header mobile-card-header">
                    <h2 className="text-black font-w600 mb-0">{t('TRANSACTION.FIAT_TRANSACTION')}</h2>
                    <div className="mobileFullWidth">
                        <Dropdown className="custom-dropdown mb-0" >
                            <Dropdown.Toggle className="btn btn-primary btn-rounded i-false" variant='' >
                                <i className="las la-download scale5 mr-3"></i> Download Report
                                <i className="fa fa-caret-down text-white ml-3" aria-hidden="true"></i>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="dropdown-menu-right right-cstm">
                                <Dropdown.Item className="" onClick={(e) => handleChangeCSVNdPDF("CSV")}>CSV</Dropdown.Item>
                                <Dropdown.Item className="" onClick={(e) => handleChangeCSVNdPDF("PDF")}>PDF</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
            </div>
            {loader === true ?
                <div>
                    <Loader open_close={loader} />
                </div>
                :
                <div className="card">
                    <div className="card-body bdr-btm-card">
                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-group position-relative">
                                    <label className="mb-2 ">
                                        <span>{t('TRANSACTION.FROM_DATE')}</span>
                                    </label>
                                    <div className="col-xs-12">
                                        <input type="date" onChange={(e) => validateFromdate(e.target.value)} value={from_date} className="form-control" />
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className="form-group position-relative">
                                    <label className="mb-2 ">
                                        <span>{t('TRANSACTION.TO_DATE')}</span>
                                    </label>
                                    <div className="col-xs-12">
                                        <input type="date" onChange={(e) => validateTodate(e.target.value)} value={to_date} className="form-control" />
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className="form-group position-relative">
                                    <label className="mb-2 ">
                                        <span>{t('FIAT.SELECT_ACCOUNT')}</span>
                                    </label>
                                    <select className="form-control webkit-none" onChange={(e) => validateAccount(e.target.value)} value={account}>
                                        <option value="">{t('FIAT.SELECT_ACCOUNT')}</option>
                                        {Useraccount && Useraccount.map((row) => (
                                            <option value={row.account_id_pk} key={row.account_id_pk}>{row.account_currency_type} ( {row.account_number} )</option>
                                        ))}
                                    </select>
                                    <i className="fa fa-caret-down down-arrow" aria-hidden="true"></i>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group position-relative">
                                    <label className="mb-2 ">
                                        <span>{t('TRANSACTION.TRANSACTION_TYPE')} </span>
                                    </label>
                                    <select className="form-control webkit-none" value={TransactionType} onChange={(event) => handleChangeTransactionType(event.target.value)}>
                                        <option value={"Fiat"}>{t('TRANSACTION.FIAT_LA')} </option>
                                        <option value={"InternalTransfers"}>{t('TRANSACTION.INTERNAL_TRANSFER_LA')} </option>
                                        <option value={"OutgoingTransfers"}>{t('TRANSACTION.OUTGOING_TRANSFER_LA')} </option>
                                    </select>
                                    <i className="fa fa-caret-down down-arrow" aria-hidden="true"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="card-body table-action-center hide-scrolllbar">

                        <div className="position-relative">
                            <div className="table-responsive" id="Fiat">
                                {fiataccount.length > 0 ?
                                    <MaterialTable
                                        title={t('TRANSACTION.FIAT_TRANSACTION')}
                                        icons={materialTableIcons}
                                        options={{ exportButton: false, paging: true, pageSize: 5, pageSizeOptions: [5, 10, 15], emptyRowsWhenPaging: false, size: 'medium' }}
                                        columns={[
                                            { title: t('TRANSACTION.DATE_LA'), field: 'date' },
                                            { title: t('TRANSACTION.TRANSACTION_DETAILS'), field: 'transaction_details' },
                                            { title: t('TRANSACTION.DEBIT_LA'), field: 'type' },
                                            { title: t('TRANSACTION.AMOUNT'), field: 'amount' },
                                            { title: t('TRANSACTION.BALANCE_LA'), field: 'balance' },
                                        ]}
                                        data={fiataccount}
                                    />
                                    : <div className="d-sm-flex d-block border-0 pb-0">
                                        <div className="pr-3 mr-auto mb-sm-0 mb-3 nofoundFullWidth">
                                            <h4 className="fs-20 text-black mb-1 nofoundTitle">{t('TRANSACTION.FIAT_TRANSACTION')} Overview</h4>
                                            <span className="fs-12 nofoundText">No Data Found</span>
                                        </div>
                                    </div>}
                            </div>
                            <div className="table-responsive" id="InternalTransfers" style={{ display: "none" }}>
                                {trasarray.length > 0 ?
                                    <MaterialTable
                                        title={t('TRANSACTION.INTERNAL_TRANSFER_LA')}
                                        icons={materialTableIcons}
                                        options={{ exportButton: false, paging: true, pageSize: 5, pageSizeOptions: [5, 10, 15], emptyRowsWhenPaging: false, size: 'medium' }}
                                        columns={[
                                            { title: t('TRANSACTION.FROM_ACCOUNT'), field: 'account_number' },
                                            { title: t('TRANSACTION.TO_EMAILID'), field: 'email_address' },
                                            { title: t('TRANSACTION.AMOUNT'), field: 'amount' },
                                            { title: t('TRANSACTION.CUR_LA'), field: 'currency' },
                                            { title: t('TRANSACTION.STATUS_LA'), field: 'status' },
                                            { title: t('TRANSACTION.VIEW_DETAILS'), field: 'popup' },
                                        ]}
                                        data={trasarray}
                                    />
                                    : <div className="d-sm-flex d-block border-0 pb-0">
                                        <div className="pr-3 mr-auto mb-sm-0 mb-3 nofoundFullWidth">
                                            <h4 className="fs-20 text-black mb-1 nofoundTitle">{t('TRANSACTION.INTERNAL_TRANSFER_LA')} Overview</h4>
                                            <span className="fs-12 nofoundText">No Data Found</span>
                                        </div>
                                    </div>}
                            </div>
                            <div className="table-responsive" id="OutgoingTransfers" style={{ display: "none" }}>
                                {outtrasarray.length > 0 ?
                                    <MaterialTable
                                        title={t('TRANSACTION.OUTGOING_TRANSFER_LA')}
                                        icons={materialTableIcons}
                                        options={{ exportButton: false, paging: true, pageSize: 5, pageSizeOptions: [5, 10, 15], emptyRowsWhenPaging: false, size: 'medium' }}
                                        columns={[
                                            { title: t('TRANSACTION.BEN_ACC_NAME'), field: 'bank_account_name' },
                                            { title: t('TRANSACTION.ACC_NO'), field: 'account_number' },
                                            { title: t('TRANSACTION.AMOUNT'), field: 'amount' },
                                            { title: t('TRANSACTION.CUR_LA'), field: 'currency' },
                                            { title: t('TRANSACTION.STATUS_LA'), field: 'status' },
                                            { title: t('TRANSACTION.VIEW_DETAILS'), field: 'popup' },
                                        ]}
                                        data={outtrasarray}
                                    />
                                    : <div className="d-sm-flex d-block border-0 pb-0">
                                        <div className="pr-3 mr-auto mb-sm-0 mb-3 nofoundFullWidth">
                                            <h4 className="fs-20 text-black mb-1 nofoundTitle">{t('TRANSACTION.OUTGOING_TRANSFER_LA')} Overview</h4>
                                            <span className="fs-12 nofoundText">No Data Found</span>
                                        </div>
                                    </div>}
                                <Modal className="modal fade" show={InternalModal} size="lg">
                                    <div className="modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h3 className="modal-title">{t('TRANSACTION.INTERNAL_TRA_INFO')}</h3>
                                                <button type="button" className="close" onClick={() => setInternalModal(false)}><span>&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <p className="fs-14 mb-1">{t('TRANSACTION.FROM_USER')}</p>
                                                        <span className="text-black">{modalFromUser}</span>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <p className="fs-14 mb-1">{t('TRANSACTION.TO_USER')}</p>
                                                        <span className="text-black">{modalToUser}</span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <p className="fs-14 mb-1">{t('TRANSACTION.FROM_ACCOUNT')}</p>
                                                        <span className="text-black">{modalFromAccount}</span>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <p className="fs-14 mb-1">{t('TRANSACTION.TO_ACCOUNT')}</p>
                                                        <span className="text-black">{modalToAccount}</span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <p className="fs-14 mb-1">{t('TRANSACTION.AMOUNT')}</p>
                                                        <span className="text-black">{modalAmount}</span>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <p className="fs-14 mb-1">{t('FIAT.EMAIL_ADDRESS')}</p>
                                                        <span className="text-black">{modalEmailAddress}</span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <p className="fs-14 mb-1">{t('TRANSACTION.CUR_LA')}</p>
                                                        <span className="text-black">{modalCurrency}</span>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <p className="fs-14 mb-1">{t('FIAT.MESSAGE_TITLE')}</p>
                                                        <span className="text-black">{modalMessage}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Modal>
                                <Modal className="modal fade" show={AccountInformation} size="lg">
                                    <div className="modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h3 className="modal-title">{t('TRANSACTION.OUTGOING_INFO')}</h3>
                                                <button type="button" className="close" onClick={() => setAccountInformation(false)}><span>&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <p className="fs-14 mb-1">{t('TRANSACTION.ACC_NO')}.</p>
                                                        <span className="text-black">{modal_outgoing_accno}</span>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <p className="fs-14 mb-1">{t('FIAT.SWIFT_TITLE')}</p>
                                                        <span className="text-black">{modal_outgoing_swiftcode}</span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <p className="fs-14 mb-1">{t('FIAT.NAME_TITLE')}</p>
                                                        <span className="text-black">{modal_outgoing_bankname}</span>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <p className="fs-14 mb-1">{t('FIAT.COUNTRY')}</p>
                                                        <span className="text-black">{modal_outgoing_country}</span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <p className="fs-14 mb-1">{t('FIAT.ABA_TITLE')}</p>
                                                        <span className="text-black">{modal_outgoing_rtn}</span>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <p className="fs-14 mb-1">{t('FIAT.LOCATION')}</p>
                                                        <span className="text-black">{modal_outgoing_location}</span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12 mb-3">
                                                        <p className="fs-14 mb-1">{t('FIAT.ADDRESS')}</p>
                                                        <span className="text-black">{modal_outgoing_address}</span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <p className="fs-14 mb-1">{t('TRANSACTION.BEN_NAME')}</p>
                                                        <span className="text-black">{modal_outgoing_cusname}</span>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <p className="fs-14 mb-1">{t('TRANSACTION.BEN_IBAN')}</p>
                                                        <span className="text-black">{modal_outgoing_cusiban}</span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12 mb-3">
                                                        <p className="fs-14 mb-1">{t('TRANSACTION.REFMESSAGE')}</p>
                                                        <span className="text-black">{modal_outgoing_refmsg}</span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12 mb-3">
                                                        <p className="fs-14 mb-1">{t('TRANSACTION.BEN_ADDRESS')}</p>
                                                        <span className="text-black">{modal_outgoing_cusaddress}</span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <p className="fs-14 mb-1">{t('TRANSACTION.AMOUNT')}</p>
                                                        <span className="text-black">{modal_outgoing_amount}</span>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <p className="fs-14 mb-1">{t('TRANSACTION.CUR_LA')}</p>
                                                        <span className="text-black">{modal_outgoing_currency}</span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12 mb-3">
                                                        <p className="fs-14 mb-1">{t('TRANSACTION.TRA_MESSAGE')}</p>
                                                        <span className="text-black">{modal_outgoing_message}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )

}
export default Fiat_Transactions;